import { Instagram } from "lucide-react";
import { CHANNELS, SITE } from "../../data/site";
import { useT } from "@/i18n/I18nContext";

export default function Footer() {
  const { t } = useT();
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-24 md:pt-32 pb-10 border-t border-[var(--tt-border)] tt-noise"
    >
      <div className="mx-auto max-w-[1480px] px-6 md:px-12">
        <p className="font-serif text-[clamp(3.5rem,12vw,11rem)] leading-[0.85] tracking-tighter text-[var(--tt-text)]">
          {t("footer.cta_l")}
          <br />
          <em className="italic font-light text-[var(--tt-gold)]">{t("footer.cta_r")}</em>
        </p>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-10 border-t border-[var(--tt-border)] pt-12">
          <div className="col-span-2 md:col-span-2">
            <p className="font-serif italic text-2xl text-[var(--tt-text)]">{SITE.brand}</p>
            <p className="mt-4 text-[var(--tt-text-dim)] font-light max-w-xs text-sm leading-relaxed">
              {t("footer.tagline")}
            </p>
            <p className="mt-6 tt-overline">{SITE.company}</p>
          </div>

          <div>
            <p className="tt-overline">{t("footer.channels_label")}</p>
            <ul className="mt-5 space-y-3">
              {CHANNELS.map((c) => (
                <li key={c.slug}>
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-channel-${c.slug}`}
                    className="tt-link-underline text-[var(--tt-text-dim)] hover:text-[var(--tt-text)] text-sm"
                  >
                    {c.name}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="https://www.instagram.com/trilhosemfuria/"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-channel-instagram"
                  className="tt-link-underline text-[var(--tt-text-dim)] hover:text-[var(--tt-text)] text-sm inline-flex items-center gap-2"
                >
                  <Instagram size={14} className="text-[var(--tt-gold)]" />
                  Instagram <span className="text-[10px] uppercase tracking-widest text-[var(--tt-text-muted)]">@trilhosemfuria</span>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="tt-overline">{t("footer.nav_label")}</p>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                [t("footer.nav.canais"), "#canais"],
                [t("footer.nav.trabalho"), "#trabalho"],
                [t("footer.nav.sobre"), "#sobre"],
                [t("footer.nav.marcas"), "#marcas"],
                [t("footer.nav.servicos"), "#servicos"],
                [t("footer.nav.contacto"), "#contacto"],
              ].map(([l, h]) => (
                <li key={h}>
                  <a
                    href={h}
                    data-testid={`footer-nav-${h.replace("#", "")}`}
                    className="tt-link-underline text-[var(--tt-text-dim)] hover:text-[var(--tt-text)]"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col md:flex-row md:items-center md:justify-between gap-4 border-t border-[var(--tt-border)] pt-8 text-xs text-[var(--tt-text-muted)]">
          <p>
            © {new Date().getFullYear()} {SITE.company}. {t("footer.copyright")}
          </p>
          <p className="tt-overline">{t("footer.credit")}</p>
        </div>
      </div>
    </footer>
  );
}
